import React, { useEffect } from 'react';
import { Flex, Skeleton } from 'antd';
import { useFormik } from 'formik';
import * as Yup from 'yup';

import { useAiProfile } from '../hooks/useAIProfile';
import * as S from '../styles/Common.styles';
import { PromptProps } from '../service/ai.interface';
import { PromptForm } from '../components/Prompt/PromptForm';
import { useCreatePrompt } from '../hooks/useCreatePrompt';
import { PromptSaveButton } from '../components/Prompt/PromptSaveButton';
import { useLazyReadAIQuery } from '../service/ai';
import { useAppSelector } from '../../../../../store';
import { selectShopCurrent } from '../../shops/store/shopSlice';

const PromptSchema = Yup.object({
    prompt: Yup.string().nullable(),
    first_message: Yup.string()
        .min(5, 'Минимум 5 символов')
        .max(5000, 'Максимум 5000 символов')
        .required('Обязательное поле'),
});

export const PromptEditContainer = () => {
    const current = useAppSelector(selectShopCurrent);
    const [getAI] = useLazyReadAIQuery();

    const { prompt, status, first_message } = useAiProfile();
    const { submit: submitPrompt, isLoading } = useCreatePrompt();

    const formik = useFormik<PromptProps>({
        initialValues: {
            prompt: prompt || '',
            first_message: first_message || '',
        },
        enableReinitialize: true,
        validationSchema: PromptSchema,
        onSubmit: submitPrompt,
    });

    useEffect(() => {
        if (current.id) {
            getAI(current.id);
        }
    }, [current.id]);

    if (status.isLoading) return <Skeleton />;

    const loading = isLoading || status.isLoading;

    return (
        <>
            <S.Title level={4}>Настроить промпт</S.Title>
            <Flex vertical gap={24}>
                <PromptForm formik={formik} />
                <PromptSaveButton loading={loading} formik={formik} />
            </Flex>
        </>
    );
};
